import {each} from "lodash";
import {Dispatch} from "redux";
import {addAlert, AlertType} from "@web2/ap-alerts";
import {apiLink} from "@web2/ap-api-routes";
import {catch400, postRequest} from "@web2/ap-request";
import {apAppLink} from "@web2/ap-routes";

import {apHistory} from "../../app/utils/history";

const passwordResetErrorText = "Błąd podczas próby wysłania prośby o zmianę hasła: ";

export const getRemindPasswordText = (email: string) => `Sukces! Za chwilę zostanie wysłana wiadomość e-mail na adres ${email}
     z prośbą o utworzenie nowego hasła. Pamiętaj, że takie wiadomości czasami wpadają do folderu SPAM.`;

export const resetPassword = (email: string) => (dispatch: Dispatch) => {
    const resetPasswordUrl = apiLink.account.passwordReset({});
    return postRequest({}, resetPasswordUrl(null), {email})
        .then((json: void) => {
            dispatch(addAlert({type: AlertType.SUCCESS, text: getRemindPasswordText(email)}, 5000));
            apHistory.push(apAppLink.login());

            return true;
        })
        .catch(
            catch400((responseError) => {
                if (responseError.appError?.nonFieldErrors) {
                    each(responseError.appError.nonFieldErrors, (message: string) => {
                        dispatch(addAlert({type: AlertType.ERROR, text: passwordResetErrorText + message}));
                    });
                }
                return false;
            })
        );
};
